import dynamic from 'next/dynamic'

export const Mealplans = dynamic(() => import('./components/Legacy/Mealplans'))
export const AccommodationGallery = dynamic(() => import('./components/GalleryLegacy'))
export const Description = dynamic(() => import('./components/Legacy/Description'))
export const PDPHeading = dynamic(() => import('./components/PDPHeadingLegacy'))
export const PDPTitle = dynamic(() => import('./components/Legacy/PDPTitle'))
export const AnchorMenu = dynamic(() => import('./components/Legacy/AnchorMenu'))
export const UserReviews = dynamic(() => import('./components/Legacy/UserReviews'))
export const StandaloneReviewsScore = dynamic(() => import('./components/Legacy/StandaloneReviewsScore'))
export const RoomTypes = dynamic(() => import('./components/Legacy/RoomTypes'))
export const GoodToKnow = dynamic(() => import('./components/Legacy/GoodToKnow'))
export const RecommendedAccos = dynamic(() => import('./components/Legacy/RecommendedAccos'))
export const AccommodationPage = dynamic(() => import('./AccommodationPage'))
export const AccommodationPageFullReact = dynamic(() => import('./AccommodationPageFullReact'))
export const LegacyDestinationSection = dynamic(() => import('./components/Legacy/DestinationSection'))
export const DestinationSection = dynamic(() => import('./components/DestinationSection'))
export const Facilities = dynamic(() => import('./components/Legacy/Facilities'))
export const PracticalInformation = dynamic(() => import('./components/Legacy/PracticalInformation'))

export default dynamic(() => import('./AccommodationPage'))
